/**
 * Environment Configuration
 *
 * Single source of truth for all environment-dependent values.
 * Vite injects VITE_* variables at build time.
 */

export const env = {
  /** Base URL for the SI Platform API backend */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api-sandbox.society-intelligence.com',

  /** Application identity */
  appName: 'Impact Core',
  version: '0.1.0',

  /** API request timeout in milliseconds */
  apiTimeout: 30_000,

  /** Whether we are running in development mode */
  isDev: import.meta.env.DEV,
} as const;
